export const tokenName = 'tokenCincel';
export const tokenV3Name = 'tokenV3Cincel';
export const expirationName = 'expirationCincel';
export const userName = 'userCincel';
export const cincelSession = 'cincelSession-data';
export const activityName = 'cincel_last_activity';

export const IDLE_TIMEOUT_OPTIONS = [
    { label: '5m', value: 300 },
    { label: '20m', value: 1200 },
    { label: '1h', value: 3600 },
    { label: '2h', value: 7200 },
    { label: '4h', value: 14400 },
    { label: '8h', value: 28800 },
];

export const MAX_FILE_SIZE = 20;

export const DEFAULT_IDLE_TIMEOUT = 3600; // 1 hour
